/* eslint-disable */
export default {
  cancel: 'Annuleren',
  pmiChangeConfirmed: 'Wijzigen',
  pmiChangeConfirmTitle: 'Instellingen voor persoonlijke meeting wijzigen?',
  pmiChangeConfirmContext:
    'Als u deze instellingen wijzigt, heeft dit invloed op alle meetings die uw persoonlijke meeting-ID of -naam gebruiken, inclusief de meetings die u al hebt gepland',
  updatePassword: 'Wachtwoord bijwerken',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
